import { Text, type TextProps } from '#app/components/Primitives/Text.js';
import { type ReactNode } from 'react';
import { css, styled } from 'styled-components';

type TextFieldSelectionTextProps = TextProps & {
  readonly children: ReactNode;
  readonly className?: string;
  readonly isDisabled?: boolean;
  readonly isPlaceholder?: boolean;
  readonly label?: string;
  readonly onClick?: () => void;
};

const Layout = styled(Text)<{ $isDisabled?: boolean; $isPlaceholder: boolean }>`
  ${({ $isDisabled, $isPlaceholder, onClick, theme }) => css`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-direction: row;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: ${$isDisabled || $isPlaceholder
      ? theme.colorsV2.gray60
      : theme.colorsV2.black};
    cursor: ${$isDisabled ? 'not-allowed' : onClick ? 'pointer' : 'default'};
  `}
`;

export const TextFieldSelectionText = ({
  children,
  className,
  isDisabled = false,
  isPlaceholder = false,
  label,
  onClick,
}: TextFieldSelectionTextProps) => {
  return (
    <Layout
      $isDisabled={isDisabled}
      $isPlaceholder={isPlaceholder}
      aria-label={label}
      as="span"
      className={className}
      flex={1}
      onClick={onClick}
      textAlign="left"
    >
      {children}
    </Layout>
  );
};

TextFieldSelectionText.displayName = 'TextField.SelectionText';
